import classNames from 'classnames';
import React, { useContext } from 'react';
import SidebarContext from './SidebarContext';
import { SIDEBAR_ORDER, SIDEBARS } from './sidebars';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMenu } from '../../../menuSlice.js';
import { setMenu } from '../../../menuSlice.js';

const SidebarTriggers = () => {
  const {
    toggleSidebar,
    currentSidebar,
  } = useContext(SidebarContext);

    const dispatch = useDispatch();
  
    const handleToggleMenu = () => {
      dispatch(toggleMenu());
    };

    const handleToggleMenuDesktop = () => {
      dispatch(setMenu());
    };



  return (
    <div className="d-flex ml-auto">
      {SIDEBAR_ORDER.map((sidebarId) => {
        const { Trigger } = SIDEBARS[sidebarId];
        const isActive = sidebarId === currentSidebar;
        return (
          <div
            className={classNames('mt-3', { 'border-primary-700': isActive })}
            style={{ borderBottom: isActive ? '2px solid' : null }}
            key={sidebarId}
          >
            <Trigger onClick={() => toggleSidebar(sidebarId)} key={sidebarId} />
       
          </div>
          
        );
      })}
           <button onClick={handleToggleMenu} className="toggle-button">
            ☰
      </button>
      <button onClick={handleToggleMenuDesktop} className="toggle-button-desktop">
            ☰
      </button>
      
    </div>
  );
};

SidebarTriggers.propTypes = {};

export default SidebarTriggers;
